// NZSC-3016 — report_issue_time CRUD 클라이언트 (Vue2 admin 포팅)
// api-admin (NZSC-3010) /api/v1/report-issue-time
// - request body: snake_case (start_date, end_date, display_text, memo, enabled)
// - response data: camelCase (seq, startDate, endDate, displayText, memo, enabled, ...)
// - 409 body: { statusCode, message: { code: 'OVERLAPPING_RANGE', message, conflicts: [...] }, error: 'Conflict' }
//   * Vue admin api 인터셉터는 error.response 를 그대로 reject → caller 에서 err.status === 409 / err.data.message.conflicts
import api from "../../utils/api";

const BASE = "/api/v1/report-issue-time";

const state = {
  _items: [],
  _total: 0,
  _page: 1,
  _limit: 200,
};

const mutations = {
  setReportIssueTimeList(state, { items, total, page, limit }) {
    state._items = Array.isArray(items) ? [...items] : [];
    state._total = total || 0;
    state._page = page || 1;
    state._limit = limit || 200;
  },
};

const actions = {
  async acReportIssueTimeList({ commit }, { page = 1, limit = 200, includeDisabled = true } = {}) {
    try {
      const res = await api.get(BASE, {
        params: {
          page,
          limit,
          include_disabled: includeDisabled ? "1" : undefined,
        },
      });
      const data = res.data?.data || {};
      commit("setReportIssueTimeList", {
        items: data.items || [],
        total: data.total || 0,
        page: data.page || 1,
        limit: data.limit || limit,
      });
      return data;
    } catch (err) {
      console.log("acReportIssueTimeList err", err.message || err);
      commit("setReportIssueTimeList", { items: [], total: 0, page: 1, limit });
      return null;
    }
  },

  async acReportIssueTimeCreate(_, payload) {
    // payload: { start_date, end_date, display_text, memo, enabled }
    const res = await api.post(BASE, payload);
    return res.data?.data;
  },

  async acReportIssueTimeUpdate(_, { seq, payload }) {
    const res = await api.patch(`${BASE}/${seq}`, payload);
    return res.data?.data;
  },

  async acReportIssueTimeDelete(_, { seq }) {
    const res = await api.delete(`${BASE}/${seq}`);
    return res.data?.data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
